import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { BannerNotification, NakedButton, Text } from '@frontend/design-system';

export const ManageProvidersAvailabilityBanner = () => {
  const { t } = useTranslation('schedule-settings');
  const { navigate } = useSettingsNavigate();

  return (
    <BannerNotification
      status='info'
      fullWidth
      css={{ marginBottom: theme.spacing(2) }}
      message={
        <Text size='medium' css={{ margin: 0 }}>
          {t('Updates to this page do not affect provider availability or online scheduling.')}
          <NakedButton
            onClick={() => navigate({ to: '/schedule/availability' })}
            css={{ color: theme.colors.primary50, textDecoration: 'underline', marginLeft: theme.spacing(0.5) }}
          >
            {t('Update availability settings')}
          </NakedButton>
        </Text>
      }
    />
  );
};
